import React from 'react';
import clsx from 'clsx';
import styles from './styles.css.js';
import DropdownStatus from '../dropdown-status/index.js';
var DropdownFooter = function (_a) {
    var _b;
    var content = _a.content;
    return (React.createElement("div", { className: clsx(styles.root, (_b = {}, _b[styles.hidden] = content === null, _b)), "aria-live": "polite", "aria-atomic": "true" }, content && React.createElement(DropdownStatus, null, content)));
};
export default DropdownFooter;
//# sourceMappingURL=index.js.map